const IsYouTubeDomainRegExp = /youtube(-nocookie)?\.com|(youtu|y2u)\.be|i\.ytimg\.com/;

export const isYoutubeVideo = (url: string): boolean => {
	return IsYouTubeDomainRegExp.test(url);
};
